import "../styles/features.css";

const features = [

{
title:"Premium Current Affairs",
desc:"Daily updated UPSC current affairs with deep analysis and exam focused explanations.",
img:"https://cdn-icons-png.flaticon.com/512/2991/2991148.png"
},

{
title:"Premium Question Banks",
desc:"Thousands of UPSC standard practice questions with explanations and topic coverage.",
img:"https://cdn-icons-png.flaticon.com/512/3135/3135755.png"
},

{
title:"Premium Notes",
desc:"Concise UPSC notes covering Polity, Economy, Geography, History and more.",
img:"https://cdn-icons-png.flaticon.com/512/2921/2921222.png"
},

{
title:"Mock Exams",
desc:"UPSC level mock tests with performance analysis and score prediction.",
img:"https://cdn-icons-png.flaticon.com/512/4315/4315445.png"
},

{
title:"Detailed UPSC Analysis",
desc:"Previous year questions and exam pattern breakdown for smart preparation.",
img:"https://cdn-icons-png.flaticon.com/512/4149/4149643.png"
},

{
title:"AI Coaching",
desc:"AI powered learning system helping you focus on weak topics.",
img:"https://cdn-icons-png.flaticon.com/512/4712/4712109.png"
},

{
title:"Law Structure",
desc:"Complete structure of Indian legal system simplified for UPSC aspirants.",
img:"https://cdn-icons-png.flaticon.com/512/3063/3063822.png"
},

{
title:"Law GS1–GS4",
desc:"Ethics, governance, society and constitutional topics explained clearly.",
img:"https://cdn-icons-png.flaticon.com/512/2910/2910791.png"
},

{
title:"IPC Sections",
desc:"Important IPC sections simplified for competitive exam preparation.",
img:"https://cdn-icons-png.flaticon.com/512/1048/1048953.png"
}

];

export default function Features(){

return(

<div className="features-page container" style={{backgroundColor:"#000000"}}>

<h2 className="features-title">
Why Choose UPSC Titan Score
</h2>

<p className="features-sub">
Modern UPSC preparation platform designed to help aspirants learn faster and smarter.
</p>

<div className="features-grid" style={{backgroundColor:"#000000"}}>

{features.map((item,index)=>(

<div className="feature-card" key={index}>

<img src={item.img} alt={item.title}/>

<h5>{item.title}</h5>

<p>{item.desc}</p>

</div>

))}

</div>

</div>

);

}